export const textFieldSx = { m: 1, width: '40ch' };

export const baseUrl = process.env.PUBLIC_URL;

export const unexpectedError =
    'Something went wrong. Please try again or contact support if the problem persists.';

export const validationError =
    'Password must be at least 8 chararcters long and contain an uppercase letter, a special character (!@$%^&*_), and a number';
